import { render } from "./CashbackRecordPage.vue?vue&type=template&id=1ed04405&scoped=true"
import script from "./CashbackRecordPage.vue?vue&type=script&lang=js"
export * from "./CashbackRecordPage.vue?vue&type=script&lang=js"

import "./CashbackRecordPage.vue?vue&type=style&index=0&id=1ed04405&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed04405"]])

export default __exports__